"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusStickerWidget = void 0;
var tslib_1 = require("tslib");
var raw_1 = require("@tableau/icons/ExcludeBaseIcon/raw");
var raw_2 = require("@tableau/icons/NotificationAlertWarningShieldSolidIcon/raw");
var raw_3 = require("@tableau/icons/NotificationCheckIcon/raw");
var raw_4 = require("@tableau/icons/NotificationInfoOutlineIcon/raw");
var React = tslib_1.__importStar(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var Icons_1 = require("../../icons/Icons");
var StickerWidget_1 = require("./StickerWidget");
var StickerIconSize = 14;
// Multi-color icons in the icons library have fixed colors, so we can only override the colors via string replace
var WarningIconSvg = function (fill1, fill2) {
    return raw_2.NotificationAlertWarningShieldSolidIconRaw(StickerIconSize).replace('#FECA63', fill1).replace('#666', fill2);
};
// These colors are from the new color system, should be replaced with design tokens eventually
var Colors = {
    DisabledBackground: '#C6CACD',
    RedBorder: '#BA0517',
    IconFill: '#FAFAFA',
    IconFillDisabled: '#939393',
    BlueBorder: '#05628A',
    NeutralBorder: '#595C5F',
    GreenBorder: '#22683E',
    TealBorder: '#0B827C',
    VioletBorder: '#730394',
    YellowBorder: '#AC4B02',
};
var StatusStickerTypeResourceMap = {
    'error': {
        getAltText: Localize_1.Messages.errorToastPrefix,
        iconSvg: function (disabled) { return raw_1.ExcludeBaseIconRaw(StickerIconSize, disabled ? Colors.IconFillDisabled : Colors.RedBorder); },
        stickerType: 'red',
    },
    'warning': {
        getAltText: Localize_1.Messages.warningToastPrefix,
        iconSvg: function (disabled) { return WarningIconSvg(disabled ? Colors.IconFillDisabled : Colors.YellowBorder, disabled ? Colors.DisabledBackground : Colors.IconFill); },
        stickerType: 'yellow',
    },
    'info': {
        getAltText: Localize_1.Messages.infoToastPrefix,
        iconSvg: function (disabled) { return raw_4.NotificationInfoOutlineIconRaw(StickerIconSize, disabled ? Colors.IconFillDisabled : Colors.BlueBorder); },
        stickerType: 'blue',
    },
    'success': {
        getAltText: Localize_1.Messages.successToastPrefix,
        iconSvg: function (disabled) { return raw_3.NotificationCheckIconRaw(StickerIconSize, disabled ? Colors.IconFillDisabled : Colors.GreenBorder); },
        stickerType: 'green',
    },
};
/** Status Stickers have built-in icons and styling, reserved for their respective uses. */
var StatusStickerWidget = function (props) {
    var resource = StatusStickerTypeResourceMap[props.stickerType];
    return React.createElement(StickerWidget_1.StickerWidget, tslib_1.__assign({}, props, { icon: React.createElement("img", { alt: resource.getAltText(), src: Icons_1.encodeSvg(resource.iconSvg(props.disabled)) }), stickerType: resource.stickerType }));
};
exports.StatusStickerWidget = StatusStickerWidget;
exports.StatusStickerWidget.displayName = 'StatusStickerWidget';
//# sourceMappingURL=StatusStickerWidget.js.map